import { parseJwt } from "../../helper/JWT";
import {BaseAuthenticationManager} from "../../manager/BaseAuthenticationManager";

/**
 *
 * @class AuthenticationManager
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/manager/AuthenticationManager.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export class AuthenticationManager extends BaseAuthenticationManager{
  impersonate(username) {
    return this.refreshToken().then(() => {
      return this.login(
        '',
        username,
        'impersonate',
        'impersonate',
        true,
      );
    })
  }

  login(centerToken, username, password, code, _impersonate = false) {
    return new Promise((resolve) => {
      const result = {
        session: {
          authToken: null,
          tokenData : {},
          refreshToken: null,
        },
        success: false,
        errorMessage : null,
        tfa_required: null
      }

      const postParam = {
        username, password, code
      };

      const headers = {
        'Content-Type': 'application/json',
        'current-version': this._currentVersion
      }

      if (_impersonate) {
        postParam['impersonate'] = true;
        headers['authorization'] = `Bearer ${this._store.state.authToken}`;
      }

      fetch(this._apiRouter.getRoute('login'), {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(postParam),
      })
        .then(response => response.json())
        .then(data => {
          const success = !!data.token
          const tfa_required = !!data.tfa_required
          const tfa_error  = !!data.tfa_error

          result.success = success
          result.tfa_required = tfa_required

          result.errorMessage = null;
          if (!success && !tfa_required) {
             result.errorMessage = 'login.invalidcredentials'
          }

          if (tfa_error) {
              result.errorMessage = 'login.invalidcode'
          }

          result.session.authToken = success ? data.token : ''
          result.session.tokenData = success ? parseJwt(data.token) : {}
          result.session.refreshToken = success ? data.refresh_token : ''

          if (_impersonate) {
            this._store.dispatch('logout');
            this._store.dispatch('resetState');
          }

          if (data?.preferredLanguage) {
            this._store.dispatch('setCurrentLanguageWithoutReload', data.preferredLanguage)
          }
          this._store.dispatch('login', result.session);

          if (success && (!tfa_required || code || _impersonate)) {
              this._store.dispatch('user/fetchAndStoreUserData');
          }

          resolve(result)
        }).catch((error) => {
          result.errorMessage = 'login.invalidcredentials';
          resolve(result)
        });
    })
  }

  requestPasswordReset(centerToken, username) {
    return new Promise((resolve) => {
      fetch(this._apiRouter.getRoute('requestPasswordReset'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username
        }),
      })
        .then(response => response.json())
        .then(data => {
          resolve(data)
        })
        .catch((error) => {
          resolve(error)
        });
    })
  }

  resetPassword(token, password) {
    return new Promise((resolve) => {
      let response = null;

      fetch(this._apiRouter.getRoute('resetPassword'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
          password
        }),
      })
        .then(r => {
          response = r
          return response.json()
        })
        .then(data => {
          resolve({data, response})
        })
        .catch((error) => {
          resolve({error, response})
        });
    })
  }
}
